


const DIGITAL_CURRENCY_ACCOUNT_SERVICE_TYPE = 'digital-currency-account'
const DIGITAL_CURRENCY_TRANSACTION_SERVICE_TYPE = 'digital-currency-transation'
const PRODUCT_RESOURCE_SERVICE_TYPE = 'product-resource'
const JOB_EMPLOYMENT_SERVICE_TYPE = 'job-employment'
const CURRENCY_EXCHANGE_SERVICE_TYPE = 'currency-exchange'
const DIGITAL_CURRENCY_ALTERNATIVE_SERVICE_TYPE = 'digital-currency-alternative'

export {
  DIGITAL_CURRENCY_ACCOUNT_SERVICE_TYPE,
  DIGITAL_CURRENCY_TRANSACTION_SERVICE_TYPE,
  PRODUCT_RESOURCE_SERVICE_TYPE,
  JOB_EMPLOYMENT_SERVICE_TYPE,
  CURRENCY_EXCHANGE_SERVICE_TYPE,
  DIGITAL_CURRENCY_ALTERNATIVE_SERVICE_TYPE
}


